import { PropsWithChildren, useCallback, useEffect, useState } from "react";

import {
    AnalyticsEventPayload,
    AnalyticsListener,
    UIAnalyticsEvent
} from "@atlaskit/analytics-next";

import { Cookie } from "@/utils/cookie";
import { useOneTrustContext } from "@/utils/onetrust-provider";

import { Tracking } from "../atl-analytics/tracking";

import { useAnalyticsClient } from "./analytics-client";

export const WacAnalyticsListener = ({ children }: PropsWithChildren) => {
    const analyticsClient = useAnalyticsClient();
    const { analyticsOptOut } = useOneTrustContext();
    const [loginUserDetected, setLoginUserDetected] = useState("false");
    useEffect(() => {
        const cookieValue = Cookie.readCookie("login_user_detected");
        if (cookieValue) {
            setLoginUserDetected(cookieValue);
        }
    }, []);

    const onEvent = useCallback(
        (event: UIAnalyticsEvent, channel?: string | undefined) => {
            if (!analyticsClient || analyticsOptOut) {
                return;
            }

            if (channel === "signup") {
                const analyticsDataList = [...event.context, event.payload];
                const analyticsEventMagnolia = analyticsDataList.reduce(
                    (mergedAnalyticsEvent, currentAnalyicsEvent) => {
                        return {
                            ...mergedAnalyticsEvent,
                            ...currentAnalyicsEvent
                        };
                    },
                    {}
                );
                Tracking.trackEvent(
                    analyticsEventMagnolia["eventName"],
                    analyticsEventMagnolia
                );
                return;
            }

            // TODO - in the future add any default context
            const processedEventPayload: AnalyticsEventPayload = {
                actionSubject: "component",
                eventType: "ui",
                source: "default",
                ...event.payload,
                attributes: {
                    ...(event.payload["attributes"] || {}),
                    loginUserDetected: loginUserDetected
                }
            };
            if (!!window?.cmsPageVariant) {
                processedEventPayload["attributes"].cmsPageVariant =
                    window.cmsPageVariant;
            }

            const ANALYTICS_TYPE = process.env["ANALYTICS_TYPE"] || "console";
            if (ANALYTICS_TYPE === "console") {
                console.log({ event: processedEventPayload });
                void analyticsClient.onEvent(null, processedEventPayload);
            } else {
                void analyticsClient.onEvent(null, processedEventPayload);
            }
        },
        [analyticsClient, analyticsOptOut, loginUserDetected]
    );

    return (
        /**
         * Current channels are:
         * - atl-global: For all auto-generated events from InitializeAutoAtlAnalytics
         * - marketing: For events generated via the React components themselves
         *
         * TODO - can add in the FabricEventsListeners to catch atlasKit and fabric components etc.
         */
        <AnalyticsListener channel={"*"} onEvent={onEvent}>
            {children}
        </AnalyticsListener>
    );
};
